import { Checkbox, Form } from 'antd'

import { TaskFormElement } from './types'

type Props = {
  key: number
  element: TaskFormElement
  required?: boolean
}

export const CheckboxElement = ({ key, element, required }: Props) => {
  return (
    <Form.Item
      name={element?.name}
      key={key}
      rules={[{ required }]}
      valuePropName="checked"
      initialValue={true}
    >
      <Checkbox>{element.label}</Checkbox>
    </Form.Item>
  )
}
